module.exports = __webpack_public_path__ + "static/media/MobilePhoneApple.a37edcbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MobilePhoneApple.png
// module id = 6120
// module chunks = 1